import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';

import useApi from '../use-api';

import type { CcmStatuses, Languages } from 'infrastructure/enums';
import type { ICampaignQuestionAnswersSelect } from 'infrastructure/interfaces';

const api = `core-2/patients/sms-campaign/question-answers`;

interface IProps {
  campaignGuid?: string;
  language?: Languages;
  groupName?: CcmStatuses | 'other';
  excludeInfoType?: boolean;
}

export const useSmsCampaignQuestionsSelect = ({
  campaignGuid,
  groupName,
  language,
  excludeInfoType,
}: IProps) => {
  const { loadData } = useApi();

  const groupNameValue =
    groupName === 'enrolled' || groupName === 'other' ? groupName : undefined;

  const { data = [], isLoading } = useQuery({
    queryKey: [api, campaignGuid, groupName, language],
    queryFn: () =>
      loadData<{ data: ICampaignQuestionAnswersSelect[] }>(api, {
        campaignGuid,
        language,
        groupName: groupNameValue,
        excludeInfoType,
      }).then((res) => {
        if (res) return res.data;
        return [];
      }),
    staleTime: STALE_TIME,
    enabled: Boolean(campaignGuid),
  });

  return {
    data,
    isLoading,
  };
};
